// Sort helpers that order rows by the RAW ISO timestamp / date value,
// never by the formatted display string. Default order is descending (newest first).
export function tsOf(v) {
  if (!v) return 0;
  const t = Date.parse(v);
  return isNaN(t) ? 0 : t;
}

export function sortByDate(rows, field, dir = "desc") {
  const arr = [...(rows || [])];
  arr.sort((a, b) => {
    const ta = tsOf(a?.[field]);
    const tb = tsOf(b?.[field]);
    return dir === "asc" ? ta - tb : tb - ta;
  });
  return arr;
}
